<template>
    <div class="calendar d-flex flex-column h-100 position-relative">
        <div style="height: 65px;">
            <navigator @updateArrowDate="updateArrowDate" :fullCalendar="fullCalendar"></navigator>
        </div>
        <!-- <filters :defaultView="defaultView" @reloadEvents="reloadEvents"></filters> -->

        <div class="calendar-content-p d-flex flexGrow1 position-relative">
            <div class="flexGrow1">
                <div class="calendar-wrapper">
                    <!-- <div id="calendar2">
                        asd
                    </div> -->
                    <div id="calendar">
                    </div>
                    <!-- <div id="calendar">
                        <div v-if="loading" class="p-3 dark">
                            Loading calendar ...
                        </div>
                    </div> -->
                </div>
            </div>

            <events></events>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { mapGetters, mapActions } from 'vuex'
    import Navigator from './Navigator'
    import Events from './Events'
    import Filters from './Filters'
    import {eventHub} from '@/main'

    export default {
        data: function() {
            return {
                fullCalendar: null,
                defaultView: 'agendaDay',
                start: null,
                end: null,
                loading: true,
                loaded: false,
                cancelEventsRequestToken: null
            }
        },
        beforeDestroy() {
            eventHub.$off('updateCalendar');
        },
        created: function() {
            this.flushEvents() // forces download of events, preventing the total/Available values on event not updating after reservation
            let currentView = this.$route.params.currentView || null;
            let expandedDay = this.$route.params.expandedDay || null;
            let expandedDate = this.nowDate();

            if (expandedDay) {
                expandedDate = expandedDay;
            }

            // Setting currentView: in store, we'll work with a 'user-readable' string
            // ('month', 'day', 'week', coming from our route, if any), but we need some
            // prefixes for the calendar (valid options are 'month', 'agendaWeek', 'agendaDay')

            if (currentView) {
                this.updateCurrentView(currentView);

                if (currentView === 'month') {
                    this.defaultView = 'month';
                }
                else {
                    this.defaultView = 'agenda' + (currentView.charAt(0).toUpperCase() + currentView.slice(1));
                }
            }
            else {
                this.updateCurrentView(this.defaultView.split('agenda').pop().toLowerCase());
            }

            // Setting the currently selected date of the calendar.
            // If there's no date supplied via route param, we'll use today's date

            this.updateExpandedDate(expandedDate);

            // Load events from API and trigger the calendar.
            // We'll use now, now+5days as default dates

            //this ensures that we have the company setting, to set the minTime scrollTime maxTime
            /*this.initCompany().then((value => {
                this.loadEvents(
                    this.formatDate(moment(expandedDate).startOf('month')),
                    this.formatDate(moment(expandedDate).endOf('month')),
                );
            }))*/

            eventHub.$on('updateCalendar',(date) => {

                // let dateTo = moment(date).add(1, 'days').format("YYYY-MM-DD");
                // this.fetchEvents(date, dateTo)
                let startDate = moment(this.fullCalendar.view.start._d).format("YYYY-MM-DD")
                let endDate = moment(this.fullCalendar.view.end._d).format("YYYY-MM-DD")
                this.fetchEvents(startDate, endDate)

            });


            // gets colors for events
            // this.downloadEventColors({
            //     supplierId: this.account.supplierId
            // })

        },
        mounted: function() {
            //createCalendar (empty)
             // this.refreshAccountData().then((data) => {
                 this.createCalendar();
                 this.loadEventForDates();
             // })
        },
        computed: {
            ...mapGetters([
                'getExpandedDay',
                'getCurrentView',
                'getFilters',
                'getEvents',
                'account',
                'getSelectedEvent',
                'getCompanySettings',
                'getStoredEvents',
                'getEventColors'
            ]),
            calendarEvents: function() {
                let output = [];
                let storedDates = this.getStoredDates;

                //console.log('calendarEvents triggered');
                return storedDates;

                //return this.getStoredDates
            },
        },
        methods: {
            ...mapActions([
                'commitEvents',
                'updateCurrentView',
                'updateExpandedDate',
                'updateSidebar',
                'pushEvent',
                'updateSelectedEvent',
                'openModal',
                'refreshAccountData',
                'initCompany',
                'downloadEvents',
                'prepareEventDates',
                'downloadEventColors',
                'flushEvents',
                'downloadSingleEvent'
            ]),
            createCalendar: function(events) {
                let vm = this;
                let calendar = $('#calendar');
                let defaultColor = 'bg-color-1';
                let canceledClass = 'eventCanceled';
                let disabledClass = 'eventDisabled';

                this.loading = false;
                this.loaded = true;

                // For more information about these parameters refer to
                // https://fullcalendar.io/docs/

                calendar.fullCalendar({
                    locale: 'en',
                    firstDay: 1,
                    allDaySlot: false,
                    navLinks: true,
                    defaultView: vm.defaultView,
                    selectHelper: true,
                    slotEventOverlap: false,
                    nowIndicator: true,
                    minTime: '00:00:00',
                    scrollTime: (this.getCompanySettings.calendarTimeStart)? this.getCompanySettings.calendarTimeStart : '08:00:00', //if initSettings havent run it defaults to 08:00:00, it happens by pressing f5 on calendar
                    maxTime: '24:00:00',
                    // aspectRatio: 2, //to help scrollTime
                    height: 'parent',
                    // contentHeight: 'parent',
                    defaultTimedEventDuration: '01:00:00',
                    timeFormat: 'H:mm',
                    slotLabelFormat: "H:mm",
                    header: false,
                    selectable: false,  // disabled for now
                    editable: false,    // disabled for now
                    events: {},
                    views: {
                        month: {
                            columnFormat: 'ddd',
                        },
                        agenda: {
                            columnFormat: 'dddd D/M',
                        },
                        agendaWeek: {
                            columnFormat: 'ddd D',
                        },
                        agendaDay: {
                            columnFormat: 'dddd D/M',
                        }
                    },

                    //Triggered when a new date-range is rendered, or when the view type switches.
                    viewRender: function(view, element){
                        console.log('viewRender Triggered from: ' + view.start.format('YYYY-MM-DD') + ' to ' + view.end.format('YYYY-MM-DD'));
                        vm.updateCurrentView(view.name);

                        //vm.loadEventForDates(
                        //    moment(view.start).format('YYYY-MM-DD'),
                        //    moment(view.end).format('YYYY-MM-DD'),
                        //);

                        //testing new smart sistem
                        vm.fetchEvents(view.intervalStart, view.intervalEnd)
                    },

                    // The events panel should update whenever we pick a specific day
                    navLinkDayClick: function(date, jsEvent) {
                        return false // this disables the click header on week view

                        let formattedDate = vm.formatDate(date);
                        let view = vm.getCurrentView;

                        // Toggle selected calendar event

                        $('.fc-event').removeClass('selected');

                        // Animate side panels

                        $('.events .list').removeClass('moved-left');
                        $('.events .more').addClass('moved-right');

                        // Update route with new date

                        vm.$router.push({ name: 'calendarExpanded', params: { currentView: view, expandedDay: formattedDate } });

                        // Update sidebar with new date's events

                        vm.updateSidebar(formattedDate);
                    },

                    // Select today's date by default

                    eventAfterAllRender: function(view) {
                        $('.fc-day-header[data-date=' + vm.getExpandedDay + ']').addClass('selected');


                    },

                    eventRender: function(event, element) {
                        if (event.id !== undefined && event.product !== undefined) {
                            let str = '';
                            str += (event.availabilityType == 2 && event.shareType == 1)? '<div class="sharedEventIcon"><img src="/static/images/event/shared_product_icon_black.svg"></div>' : ''
                            let now = moment().add(moment().utcOffset(), 'minutes');
                            let availability = null
                            if(event.availabilityType == 1){
                                availability = 'Unlimited'
                            } else if(event.availabilityType == 2){
                                if(event.shareType == 1){
                                    availability = event.quantityAvailable
                                } else {
                                    availability = event.quantityAvailable
                                }
                            } else {
                                availability = event.quantityAvailable
                            }
                            //creates Array of used resources names
                            let resourceOnEvent = [];
                            for (let resource of event.eventResources) {
                                resourceOnEvent.push(resource.name);
                            }
                            let strings = {
                                availability: '<div class="d-block fc-title ">Available: ' + availability,
                                //booked: '<div class="d-block fc-title ">Booked: ' + event.quantityBooked +'</div>', // removed - check store calendar.js -> state.filters
                                product: '<div class="d-block fc-title"><b>' + eventNameToShow(event) + '</b></div>',
                                resource: '<div class="d-block fc-title">' + resourceOnEvent.join(', ') + '</div>',
                                // transport: '<div class="d-block fc-title">' + event.product.transport.name  + '</div>',
                                transport: '<div class="d-block fc-title"></div>',
                            };

                            function eventNameToShow (){
                                let outputName = null

                                if(event.nameAlias){
                                    outputName = event.nameAlias
                                } else {
                                    outputName = event.product.name
                                }

                                // if is canceled
                                if(event.status == -1){
                                    outputName += ' (Canceled)'
                                }

                                return outputName
                            }

                            // Build availability string with allotted spaces

                            if (event.allotted !== undefined && event.allotted > 0) {
                                strings.availability += ' <span>(' + event.allotted + ' allotted)</span></div>';
                            }
                            else {
                                strings.availability += '</div>';
                            }

                            // if event has no reseource removes the resource string
                            if(resourceOnEvent.length < 1){
                                strings.resource = '';
                            }


                            // Append information as needed for each true checkbox

                            for (let filter in vm.getFilters) {

                                if (vm.getFilters[filter]) {
                                    str += strings[filter];
                                }
                            };

                            // Past events will be 'faded'.
                            // Events which started in the past but are still valid won't

                            //debug
                            //console.log('event name: '+event.product.name);
                            //console.log('event start: '+moment(event.start).format('HH:mm'));
                            //console.log('event end: '+moment(event.end).format('HH:mm'));
                            //console.log('now: '+now.format('HH:mm'));

                            //there is a problem with DST that make the past class being applied only one hour after the end of the event

                            if ((!event.end && moment(event.start).isBefore(now)) || (moment(event.end).isBefore(now))) {
                                element.addClass('past');
                            }

                            //if event status is -1 (Canceled)
                            if(event.status == -1){
                                element.addClass(canceledClass);
                            }

                            //if event status is -2 (Disabled)
                            if(event.status == -2){
                                element.addClass(disabledClass);
                            }

                            // if event has any booking
                            if(event.quantityBooked > 0) {
                                element.addClass('hasBookings');
                            }

                            // if event is Virtual Roster we add a decoration
                            if(event.shareType === 2) {
                                element.addClass('virtualRooster');
                            }

                            // Add the right color for each event (taken from its product).
                            // When creating a brand new event we still don't have a color so we default
                            // to defaultColor

                            if (event.product !== undefined && event.product.color !== undefined) {
                                //get event color from store
                                let color = vm.getEventColors.filter(function(storedColor){
                                    return event.product.color == storedColor.id;
                                })
                                //element.addClass('bg-color-' + event.product.color);
                                if(color && color.length > 0){
                                element.css({
                                        'background-color': color[0].code,
                                        //'border-color': color[0].codeSecundary
                                    });
                                }
                            }
                            else {
                                element.addClass(defaultColor);
                            }

                            // Append information to the event

                            element.find('.fc-time').after(str);

                            /*
                            $(element).attr('data-original-title', '<div class="d-flex"><div class="bg-' + product.color + ' mt-1 mr-2 circle"></div><div class="bold"><div>09:00 to 11:30</div>' + product.name + '</div></div>');
                            $(element).tooltip({
                                container: 'body',
                                html: true
                            });
                            */
                        }
                    },

                    // Update the event through the API if the timeframes
                    // have changed after drag-and-drop

                    eventDrop: function(event, delta, revertFunc) {
                        if (delta > 0) {
                            vm.pushEvent(event);
                        }
                    },

                    // Update the event through the API if the timeframes
                    // have changed after resizing

                    eventResize: function(event, delta, revertFunc) {
                        if (delta > 0) {
                            vm.pushEvent(event);
                        }
                    },

                    // Open the event's details in the side panel when clicking on it
                    // on the calendar

                    eventClick: function(calEvent, jsEvent, view) {
                        // vm.downloadSingleEvent(calEvent.id).then(response => {
                        //     console.log('event clicked', response);
                        // })
                        // Update the selected event

                        vm.updateSelectedEvent(calEvent.id);

                        // Toggle selected calendar event

                        $('.fc-event').removeClass('selected');
                        $(this).addClass('selected');

                        // Animate side panels

                        $('.events').addClass('showingMore');
                        $('.events .list').addClass('moved-left');
                        $('.events .more').removeClass('moved-right');
                    },

                    // Trigger the 'add event' modal whenever we click on an empty spot
                    // of the calendar

                    select: function(start, end) {
                        vm.start = start;
                        vm.end = end;

                        //vm.openModal('EventAdd');
                    }
                });

                // We need to set the right date AFTER the calendar has been loaded,
                // otherwise we wouldn't have any vuex data to use (async load).
                // After everything is rendered we'll push the correct date, stored
                // in expandedDay

                calendar.fullCalendar('gotoDate', vm.getExpandedDay);
                // calendar.fullCalendar('option', 'contentHeight',
                //     $('.calendar-content-p').height()
                // );
                //calendar.fullCalendar( 'gotoDate', moment().add(12, 'hour') );
                this.fullCalendar = calendar.fullCalendar('getCalendar');
                // vm.$set(vm, 'fullCalendar', calendar.fullCalendar('getCalendar'))
            },
            loadEventForDates: function(startDate, endDate) {
                //date format: YYYY-MM-DD
                if(startDate == undefined){
                    startDate = moment(startDate).format('YYYY-MM-DD');
                }
                endDate = moment(endDate).subtract(1, 'days').format('YYYY-MM-DD');
                if(startDate && endDate){
                    this.loadEvents(
                        startDate,
                        endDate
                    )
                }

            },
            async loadEvents(start, end) {

                // Clear all events in case we're reloading the calendar view

                //if (this.loaded) {
                //    this.loading = true;
                //    $('#calendar').fullCalendar('removeEvents');
                //}

                //old system
                /*
                //this cancels the last request if a new one is made
                if(this.cancelEventsRequestToken){
                    this.cancelEventsRequestToken.cancel('Operation canceled by the user.');
                }

                try {
                    await this.refreshAccountData();

                    let CancelToken = axios.CancelToken;
                    let source = CancelToken.source();
                    this.cancelEventsRequestToken = source;

                    console.log('strting request');
                    this.loading = true;
                    let response = await axios.get('api/calendar/GetEvents', {
                            params: {
                                supplierId: this.account.supplierId,
                                dateFrom: start,
                                dateTo: end
                            },
                            cancelToken: source.token
                        }
                    ).catch(function(thrown) {
                        if (axios.isCancel(thrown)) {
                            console.log('Request canceled', thrown.message);
                        } else {
                            // handle error
                        }
                    });


                    if (response && response.status === 200) {
                        this.commitEvents(response.data.events);
                        console.log('Request done');
                        this.loading = false;

                            //debug
                            //console.log('rerenderEvents with ', start, end, ' and events', response.data.events);
                            $('#calendar').fullCalendar('removeEvents');
                            $('#calendar').fullCalendar('addEventSource', response.data.events);

                            //add events to store
                            this.loading = false;

                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
                */

                //new system
                // this.downloadEvents({
                //     supplierId: this.account.supplierId,
                //     dateFrom: start,
                //     dateTo: end
                // })
            },
            reloadEvents: function(data) {
                this.loadEvents(data.start, data.end);
            },
            updateArrowDate: function(dates) {
                // If the date we have just clicked on is not within our stored monthly events,
                // we'll need to trigger loadEvents again

                if (moment(dates.newDate).isBefore(moment(dates.oldDate).startOf('month')) ||
                    moment(dates.newDate).isAfter(moment(dates.oldDate).endOf('month'))) {
                    this.loadEvents(
                        this.formatDate(moment(dates.newDate).startOf('month')),
                        this.formatDate(moment(dates.newDate).endOf('month')),
                    );
                }
            },
            fetchEvents: function(fromDate, toDate) {
                let vm = this;
                this.downloadEvents({
                    supplierId: this.account.supplierId,
                    dateFrom: fromDate,
                    dateTo: toDate
                }).then(function(){
                    $('#calendar').fullCalendar('removeEvents');
                    $('#calendar').fullCalendar('addEventSource', vm.getStoredEvents);

                })
            }
        },
        components: {
            Navigator,
            Events,
            Filters
        }
    }


</script>


<style lang="scss">
    @import '../../assets/scss/_variables.scss';


    .calendar{
        //height: 94vh;

        .calendar-content-p {
            // -p added because this style is not scoped and was messing a DatePicker (vue2-datepicker)
            // height: 100%;
            //overflow-x: hidden; // comments ending with // try to solve the scrollTime issue
            //overflow-y: auto;   //
        }
    }


    .calendar-wrapper {
        //height: calc(100vh - 20.5vh);
        //overflow-y: scroll; //
        // overflow: auto;
        height: 100%;
        // height: 500px;
    }


    .fc {

        .fc-now-indicator {
            border: 1px solid rgba($brand, 0.6);
        }

        .fc-scroller {
            //height: auto !important; //commenting this makes scrollTime work    //
            //overflow-y: hidden !important;  //
        }

        .fc-time-grid .fc-slats td {
            height: 1.5rem;
        }

        thead {
            border: 0;

            td {
                border: 0;
                font-size: $font-size-small;
                padding: 0.9rem 0;
            }
        }

        th {
            border: 0;

            &.fc-day-header {
                // &.selected {
                //     >a {
                //         color: $lightest;
                //         background-color: $brand;
                //         border-radius: 10rem;
                //         padding: 0.4rem 0.75rem;
                //     }
                // }
            }

            &.fc-day-header {
                &.fc-today {
                    >a {
                        color: $lightest;
                        background-color: $brand;
                        border-radius: 10rem;
                        padding: 0.4rem 0.75rem;
                    }
                }
            }
        }

        td {
            border: 1px solid $light;

            &.fc-today,
            &.fc-past,
            &.fc-future {
                background: transparent;
            }
        }

        .fc-event {
            // border: 0;
            border-color: $medium;
            border-radius: 0;
            margin: 0 1%;
            padding: 1%;

            &.eventCanceled{
                border-color: $color-6;
                border-width: 2px;
                border-style: solid;
                // opacity: 0.75;

                background: repeating-linear-gradient(
                  45deg,
                  $color-6,
                  $color-6 10px,
                  lighten($color-6, 5%) 10px,
                  lighten($color-6, 5%) 20px
                );
            }

            &.eventDisabled{
                // border-color: $dark;
                // border-width: 2px;
                // border-style: solid;
                // opacity: 0.75;

                background-color: $light !important;
                color: $dark !important;
                // opacity: 0.8;
            }

            &.selected {
                border: 1px solid $lightest;
                outline: 1px dashed $dark;
            }

            .sharedEventIcon{
                position: absolute;
                right: 0;
                top: 0;
            }
        }

        .fc-body>tr>td.fc-widget-content {
            border: 0;
            background-color: $lightest;
        }

        .fc-time-grid-event .fc-time,
        .fc-time-grid-event .fc-title {
            //font-size: $font-size-normal;
            //font-family: 'Open Sans Semibold', Helvetica, Arial, sans-serif;
        }


        .fc-agendaWeek-view {
            width: 100%;
            background-color: white;
            border-bottom: 1px solid #C1C3CD;


            .fc-time-grid-event {
                // width: 15%;
                // min-width: 12px;
                // max-width: 18px;

                .fc-content {
                    //display: none;

                    .virtualRooster{
                        background: rgba(0,0,0,0.3);
                        height: 12px;
                        width: 12px;
                        border-radius: 50%;
                        position: absolute;
                        right: 5px;
                        top: 5px;

                    }


                }
            }
        }

        .fc-view-container{
            display: flex;
            flex-direction: column;

        }

        .fc-time-grid .fc-event-container {
            // margin-right: 25%;
        }

        .fc-time-grid .fc-slats td {
            text-transform: uppercase;
            font-size: $font-size-small;
        }

        .fc-agendaDay-view {
            thead td {
                padding: 0.5rem 0 0.75rem;
                background-color: white;
                border-bottom: 1px solid #C1C3CD;

            }

            th.fc-day-header {
                text-align: left;


                > span {
                    color: $darker;
                    background-color: transparent;
                    border-radius: 0;
                    padding: 0;
                    font-size: $font-size-larger;
                }

                &.fc-today {
                    > span {
                        font-family: 'Open Sans Semibold', Helvetica, Arial, sans-serif;
                    }
                }
            }

            .fc-event {
                padding: 3px 5px;
            }

            .fc-time-grid-event .fc-time, .fc-time-grid-event .fc-title {
                font-size: 0.75rem;
            }
        }

        .fc-month-view {
                background-color: white;
                border-bottom: 1px solid #C1C3CD;
            .fc-day-grid-event {
                margin: 1% 0;
                padding: 0.5% 1%;



            }
        }
    }


// calendar event card
.fc-event {
    //display: none;

    &.virtualRooster{
        opacity: 0.8;

        &::after{
            content: '';
            background: rgba(0,0,0,0.3);
            height: 12px;
            width: 12px;
            border-radius: 50%;
            position: absolute;
            right: 5px;
            top: 5px;
        }

        &.hasBookings{
            opacity: 1;
        }
    }
}


    // fix calendar height
    #calendar{
        // display: flex;

        .fc-view-container{

            .fc-view{
                // display: flex;
                // flex-direction: column;

                & > table{
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;

                    .fc-head{
                    }

                    .fc-body{
                        overflow: auto;
                        flex-grow: 1;
                    }
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// Calendar.vue?60a94a56